import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Financing() {
  return <section className="py-24 bg-sapper-dark border-y border-sapper-olive/30" data-id="element-47">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-48">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-49">
          {/* Left Column */}
          <div className="lg:w-3/5" data-id="element-50">
            <h2 className="font-condensed font-bold text-5xl sm:text-6xl text-sapper-white uppercase tracking-tight mb-6" data-id="element-51">
              MISSION FINANCING AVAILABLE.
            </h2>
            <p className="font-sans text-lg text-sapper-gray mb-8 max-w-2xl" data-id="element-52">
              Deploy your new system today with 0% APR financing options. We
              also maximize your Arizona utility rebates (APS, SRP) to lower
              your total mission cost.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-8" data-id="element-53">
              {['Synchrony Financial', 'GreenSky', 'Wisetack', 'Utility Rebate Processing'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-54">
                  <CheckCircle2 className="w-5 h-5 text-sapper-red" data-id="element-55" />
                  <span className="font-mono text-sm text-sapper-white" data-id="element-56">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:w-2/5 w-full" data-id="element-57">
            <div className="bg-sapper-olive/20 border border-sapper-olive/50 p-8 text-center relative" data-id="element-58">
              {/* Corner Accents */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-sapper-red" data-id="element-59" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-sapper-red" data-id="element-60" />

              <div className="font-condensed font-black text-6xl sm:text-7xl text-sapper-white mb-2" data-id="element-61">
                $3,500<span className="text-sapper-red" data-id="element-62">+</span>
              </div>
              <div className="font-mono text-sm text-sapper-gray tracking-widest uppercase mb-4" data-id="element-63">
                AVERAGE REBATE + TAX CREDIT SAVINGS
                <br data-id="element-64" />
                ON QUALIFYING SYSTEMS
              </div>
              <p className="font-sans text-xs text-sapper-gray/60 mt-6" data-id="element-65">
                * Savings vary based on equipment SEER2 rating, utility
                provider, and tax eligibility. Consult your tax professional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}